import {
    FETCH_CALENDAR_APPOINTMENTS_REQUEST,
    FETCH_CALENDAR_APPOINTMENTS_SUCCESS,
    FETCH_CALENDAR_APPOINTMENTS_FAILURE,
  } from "./FetchCalendarAppointmentsTypes";
  
  const initialState = {
    loading: false,
    calendarAppointments: [],
    error: "",
  };
  
  const reducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_CALENDAR_APPOINTMENTS_REQUEST:
        return {
          ...state,
          loading: true,
        };
      case FETCH_CALENDAR_APPOINTMENTS_SUCCESS:
        return {
          loading: false,
          calendarAppointments: action.payload,
          error: "",
        };
      case FETCH_CALENDAR_APPOINTMENTS_FAILURE:
        return {
          loading: false,
          calendarAppointments: [],
          error: action.payload,
        };
      default:
        return state;
    }
  };
  
  export default reducer;
  